import { Record } from "immutable";
import type { RecordOf } from "immutable";
import { SET_ACCOUNTS_MODULES } from "../../helpers/constants";
import type {
  Actions,
  LinkingSettings,
  ResourceSettings,
  SitemapSettings,
  DocumentSettings,
  SetAccountModule,
} from "../../actions/accountModules";

type DefaultStateType = {
  linking: Partial<LinkingSettings>,
  resource: Partial<ResourceSettings>,
  sitemap: Partial<SitemapSettings>,
  document: Partial<DocumentSettings>,
};

const defaultState: DefaultStateType = {
  linking: {},
  resource: {},
  sitemap: {},
  document: {},
};

export const makeState = Record(defaultState);

export type State = RecordOf<DefaultStateType>;

export const initialState: State = makeState({});
export const initAccountModulesState = (): State => initialState;

// eslint-disable-next-line default-param-last
const accountModulesReducer = (state: State = initialState, action: Actions): State => {
  switch (action.type) {
    case SET_ACCOUNTS_MODULES: {
      const {
        accountModule: { name, settings },
      } = action as SetAccountModule;
      return state.set(name, settings);
    }
    default:
      return state;
  }
};

export default accountModulesReducer;
